/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Choice_Keep_CrmInputs */

const cs_ebr_choice_keep_crm = /** @type {(inputs: Ebr_Choice_Keep_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponechat CRM`)
};

const en_ebr_choice_keep_crm = /** @type {(inputs: Ebr_Choice_Keep_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep CRM`)
};

/**
* | output |
* | --- |
* | "Keep CRM" |
*
* @param {Ebr_Choice_Keep_CrmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_choice_keep_crm = /** @type {((inputs?: Ebr_Choice_Keep_CrmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Choice_Keep_CrmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_choice_keep_crm(inputs)
	return cs_ebr_choice_keep_crm(inputs)
});